import React from "react";
import { Link } from "react-router-dom";
import BlocksDark from "../../../Assets/TheBlocksDark.svg";
import { HiMailOpen } from "react-icons/hi";
import { AiOutlineTwitter, AiFillInstagram } from "react-icons/ai";
import { Badge } from "../Badges/Badge";

const Footer = () => {
  return (
    <footer>
      <div className="footer-container">
        <section className="footer-links">
          <div className="link-section">
            <label>Products</label>
            <div className="line-with-badge">
              <Link to="/apps/hsa">Shoebox</Link>
              <Badge badge="new" />
            </div>
            <Link to="/apps/calculators">Calculators</Link>
            <Link to="/apps">All Apps</Link>
            <a href="https://theblocks.substack.com">Blog</a>
          </div>

          <div className="link-section">
            <label>Resources</label>
            <Link to="/terms-of-use">Terms of Use</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/feedback">Feedback</Link>
          </div>

          <div className="link-section">
            <label>Company</label>
            <Link to="/roadmap">Roadmap</Link>
            <Link to="/about">About</Link>
          </div>
        </section>
        <section className="footer-copyright">
          <img alt="The Blocks logo" src={BlocksDark} />
          <div>
            <span>The Blocks Lab LLC &copy; {new Date().getFullYear()}.</span>{" "}
            <span>All Rights Reserved.</span>
          </div>
        </section>
      </div>
    </footer>
  );
};

export default Footer;
